<ng-container *ngIf="isInit">
  <ng-container *ngIf="user && company">
    <!-- <ng-container *ngIf="!isProduction">
      <button class="toggleLayout" (click)="toggleLayout()">Layout {{layoutABtest}}</button>
    </ng-container> -->

    <ng-container *ngTemplateOutlet="dashboarDefault"></ng-container>
    
    <!-- <ng-container [ngSwitch]="dashboardLayout$()">
      <ng-container *ngSwitchCase="'playmetrics'">
        <ng-container *ngTemplateOutlet="dashboardPlaymetrics"></ng-container>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="dashboarDefault"></ng-container>
      </ng-container>
    </ng-container> -->
  </ng-container>
</ng-container>


<ng-template #dashboarDefault>
  <ng-container *ngIf="company && companyEureso && companyEureso.localFinancialStatements; else missingFinancials">
    <app-dashboard-overview [company]="company" [user]="user" [layout]="layoutABtest"></app-dashboard-overview>
  </ng-container>

  <div class="container-expanded" *ngIf="company && companyEureso  && companyEureso.localFinancialStatements">
    <app-company-identity [company]="companyEureso" [ateco]="companyAteco" [piva]="companyPiva"></app-company-identity>  
    <ng-container *ngTemplateOutlet="promoSection"></ng-container>
    
    <!-- <ng-container *ngIf="companyEureso && companyPiva && companyAteco && reportProcessing$()"> -->
      <ng-container *ngTemplateOutlet="productrelated"></ng-container>
    <!-- </ng-container> -->
  </div>
</ng-template>

<ng-template #productrelated>
  <section class="container-fluid bg-white pb--24 pt--24 pt--lg-64 pb--lg-64">
    <products-related></products-related>
  </section>
</ng-template>

<ng-template #promoSection>
  <ng-container *ngIf="dashboardLayout$() === 'playmetrics' && !showProductToPromote$();">
      <ng-container *ngTemplateOutlet="promoPlaymetrics"></ng-container>
    </ng-container>
    <ng-container *ngIf="showProductToPromote$()">
      <app-promo-product  [productIds]="productIdsToPromote$()"></app-promo-product>
    </ng-container>
</ng-template>

<ng-template #promoteReport>
  <promo-report />
</ng-template>

<ng-template #promoPlaymetrics>
  <!-- check if playmetrics purchased esle promote related -->
  <promo-playmetrics />
</ng-template>


<ng-template #missingFinancials>
  <company-data-error [errors]="companyAnalizingErrors$()" [company]="companyEureso"
    [piva]="companyPiva"></company-data-error>
  <div class="container-expanded bg-white">
    <products-overview></products-overview>
  </div>
</ng-template>



<ng-template #dashboardPlaymetrics>
  <ng-container *ngIf="company && companyEureso && companyEureso.localFinancialStatements; else missingFinancials">
    <app-dashboard-overview [company]="company" [user]="user" [layout]="layoutABtest"></app-dashboard-overview>
    <app-company-identity [company]="companyEureso" [ateco]="companyAteco" [piva]="companyPiva"></app-company-identity>
    <!-- <app-dashboard-playmetrics></app-dashboard-playmetrics> -->
    
  </ng-container>

</ng-template>